import { FileText, Phone } from "lucide-react";
import { Link } from "react-router-dom";

const MobileStickyBar = () => (
  <div
    className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-brand-blue/15 px-4 py-3 flex gap-3 z-40"
    data-testid="mobile-sticky-bar"
  >
    <a
      href="tel:0184160307"
      className="flex-1 bg-brand-red text-white rounded-full py-3 text-xs uppercase font-semibold flex items-center justify-center gap-2"
      data-testid="mobile-sticky-call"
    >
      <Phone size={16} />
      Appelez
    </a>
    <Link
      to="/contact"
      className="flex-1 border border-brand-blue/50 text-brand-blue rounded-full py-3 text-xs uppercase font-semibold flex items-center justify-center gap-2"
      data-testid="mobile-sticky-quote"
    >
      <FileText size={16} />
      Devis
    </Link>
  </div>
);

export default MobileStickyBar;
